import { Table } from "react-bootstrap";
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import "../components/Reminder.css";
import { API_URL } from "../App";
import { UserDataContext } from "../components/UserDataContext";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import useCountStore from "../components/store";

export default function DataBowCalendar() {
  const { userData } = useContext(UserDataContext);
  const [data, setData] = useState([]);
  const [id, setId] = useState();
  const [description, setDescription] = useState("");
  //const [url, setUrl] = useState("");
  const count = useCountStore((state) => state.count);
  const setCount = useCountStore((state) => state.setCount);

  useEffect(() => {
    const fetchData = async () => {
      const url = `${API_URL}/getuserbowcalendar/${userData.cookie}`;
      try {
        const response = await axios.get(url);
        if (Array.isArray(response.data)) {
          setData(response.data);
        } else {
          setData([]);
        }
      } catch (error) {
        console.error(
          "Błąd podczas pobierania danych. Najprawdopodobniej utracono połączenie z internetem.",
          error
        );
        setData([]);
      }
    };

    if (userData && count) {
      fetchData();
      const intervalId = setInterval(fetchData, 1000);
      return () => clearInterval(intervalId);
    }
  }, [userData, count]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const [open, setOpen] = useState(false);
  const handleOpen = (id) => {
    setOpen(true);
    setId(id);
    setDescription("");
  };

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };

  const handleClose = () => setOpen(false);
  const handleDelete = async (e) => {
    let url;
    let active;

    if (e.target.name === "onlyDescription") {
      active = 1;
      url = API_URL + `/deleteremindermedcalendar/${userData.cookie}/${active}`;
    }
    if (e.target.name === "delete") {
      active = 0;
      url = API_URL + `/deleteremindermedcalendar/${userData.cookie}/${active}`;
    }

    try {
      const response = await axios.put(
        url,
        { id: id, description: description },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      //console.log(response.data);
      if (response.data.error === 200) {
        setCount(count + 1);
      }
    } catch (error) {
      console.error("Błąd podczas próby skasowania elementu", error);
    }

    setOpen(false);
  };

  if (userData && userData.grpAdmin === "1") {
    return (
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{
            component: "form",
            onSubmit: (event) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              const formJson = Object.fromEntries(formData.entries());
              const description = formJson.description;
            },
          }}
        >
          <DialogTitle>Potwierdzenie</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Potwierdzenie przyjęcia dawki leku. W przypadku nie przyjęcia leku
              proszę nie potwierdzać. W następnym dniu ten komunikat się nie
              pojawi.
            </DialogContentText>
            <TextField
              autoFocus
              autoComplete="off"
              required
              margin="dense"
              id="description"
              name="description"
              label="Uwagi, np. ciśnienie, tętno ..."
              type="text"
              fullWidth
              variant="standard"
              value={description}
              onChange={handleDescriptionChange}
            />
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={handleClose}>
              Nie
            </Button>
            <Button
              variant="contained"
              name="delete"
              onClick={handleDelete}
              type="submit"
            >
              TAK
            </Button>
            <Button
              variant="outlined"
              onClick={handleDelete}
              type="submit"
              name="onlyDescription"
            >
              Tylko opis
            </Button>
          </DialogActions>
        </Dialog>
        <h5>Potwierdzenie przyjęcia leku.</h5>
        <h6>
          Na liście znajdują się leki do zażycia w bieżącym dniu i ewentualne
          potwierdzenie przyjęcia leku z dnia poprzedniego.
        </h6>
        <Table striped bordered hover className="table red-border">
          <thead>
            <tr>
              <th className="center">Lek</th>
              <th className="center">Dawka</th>
              <th className="center">Data</th>
              <th className="center">Pora</th>
              <th className="center">Potwierdź</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(data) && data.length > 0 ? (
              data.map((item) => (
                <tr key={item.id}>
                  <td
                    data-label="Lek"
                    className="center"
                    style={item.forgotten === "1" ? { color: "red" } : {}}
                  >
                    {item.bow}
                  </td>
                  <td
                    data-label="Dawka"
                    className="center"
                    style={item.forgotten === "1" ? { color: "red" } : {}}
                  >
                    {item.dose}
                  </td>
                  <td
                    data-label="Data"
                    className="center"
                    style={item.forgotten === "1" ? { color: "red" } : {}}
                  >
                    {item.datebow}
                  </td>
                  <td
                    data-label="Pora"
                    className="center"
                    style={item.forgotten === "1" ? { color: "red" } : {}}
                  >
                    {item.part}
                  </td>
                  <td data-label="Potwierdź" className="center">
                    {item.is_active === "1" && (
                      <Button
                        variant="contained"
                        onClick={() => handleOpen(item.id)}
                      >
                        <i className="fa-solid fa-pills"></i>
                      </Button>
                    )}
                    {item.is_active === "0" && (
                      <Button variant="contained">
                        <i className="fa-solid fa-check"></i>
                      </Button>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="center">
                  Brak danych do wyświetlania
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    );
  }
}
